import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/base';
import { ReplaySubject } from 'rxjs';
import { MemberFirm } from '@shared/models/member-firm.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MemberFirmService extends BaseApiService {
  get selectedMemberFirmId(): number {
    return this._selectedMemberFirmId;
  }

  set selectedMemberFirmId(value: number) {
    this._selectedMemberFirmId = value;
  }

  get memberFirms$() {
    return this.memberFirmsSubj$.asObservable();
  }

  get memberFirmsRecord$() {
    return this.memberFirms$.pipe(
      map(res =>
        res.reduce((acc, curr) => {
          acc[curr.id] = {
            name: curr.name,
            code: curr.countryCode.toLowerCase()
          };
          return acc;
        }, {})
      )
    );
  }

  private memberFirmsSubj$ = new ReplaySubject<MemberFirm[]>(1);
  private _selectedMemberFirmId: number;

  constructor(private http: HttpClient) {
    super();
  }

  public init() {
    this.http.get<MemberFirm[]>(`${this.queryBaseUrl}/member-firm`).subscribe(data => {
      const mappedWithGlobal = data.map(item => {
        return !item.countryCode ? { ...item, countryCode: 'global' } : item;
      });
      this.memberFirmsSubj$.next(mappedWithGlobal);
    });
  }
}
